import React, { useEffect, useState } from 'react';
import { useAuthStore } from '../lib/auth';
import { dashboardAPI } from '../lib/api';
import { Loader2 } from 'lucide-react';

const MetricCard = ({ title, value }) => (
  <div className="card-rtb">
    <p className="text-[#A1A1AA] text-sm font-medium uppercase tracking-wide">{title}</p>
    <p className="text-white text-3xl font-bold mt-2 font-heading break-words">{value}</p>
  </div>
);

export default function PerformanceInsightsPage() {
  const { user } = useAuthStore();
  const [loading, setLoading] = useState(true);
  const [metrics, setMetrics] = useState({
    tasks_completed_30d: 0,
    audit_pass_rate: 0,
    incident_count: 0,
    equipment_fault_count: 0,
  });

  useEffect(() => {
    const load = async () => {
      const siteId = user?.venue_ids?.[0];
      if (!siteId) {
        setLoading(false);
        return;
      }

      try {
        const response = await dashboardAPI.getPerformanceInsights(siteId);
        setMetrics(response?.data || {});
      } catch (error) {
        console.error('Failed to load performance insights:', error);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [user?.venue_ids]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <Loader2 className="w-8 h-8 text-[#FF6600] animate-spin" />
      </div>
    );
  }

  return (
    <div className="space-y-6" data-testid="performance-insights-page">
      <div>
        <h1 className="font-heading text-3xl md:text-4xl font-bold text-white uppercase tracking-tight">Performance Insights</h1>
        <p className="text-[#A1A1AA] mt-1">Core site analytics for the last 30 days.</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        <MetricCard title="Tasks Completed (30d)" value={metrics.tasks_completed_30d || 0} />
        <MetricCard title="Audit Pass Rate" value={`${metrics.audit_pass_rate || 0}%`} />
        <MetricCard title="Incident Count" value={metrics.incident_count || 0} />
        <MetricCard title="Equipment Fault Count" value={metrics.equipment_fault_count || 0} />
      </div>
    </div>
  );
}
